import { HealthcareFacilityUnit } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { AutoLayout, Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';
import { HealthcareBasicData } from '../../../common/HealthcareBasicData';
import { HealthcareParentBasicDataPanel } from '../../../common/HealthcareParentBasicDataPanel';

import { HealthcareFacilityUnitUpdateForm } from './form/HealthcareFacilityUnitUpdateForm';
import { HealthcareFacilityUnitUpdateFormLoader } from './form/HealthcareFacilityUnitUpdateForm.loader';
import { HealthcareFacilityUnitUpdateModalConfirmButton } from './HealthcareFacilityUnitUpdateModalConfirmButton';

type HealthcareFacilityUnitUpdateModalProps = {
   readonly onCancel: VoidFunction;
   readonly healthcareFacilityUnitId: HealthcareFacilityUnit['id'];
   readonly healthcareParentData: HealthcareBasicData;
   readonly onDataChanged: VoidFunction;
};

export const HealthcareFacilityUnitUpdateModal = (props: HealthcareFacilityUnitUpdateModalProps): JSX.Element => {
   return (
      <Modal
         title={healthcareOrganizationTranslationKeys.editHealthcareFacilityUnitData}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.WIDE}
         testId={'HealthcareFacilityUnitUpdate'}
         shouldCloseOnEsc={false}
         shouldCloseOnOverlayClick={false}
         visible
      >
         <AutoLayout as={'div'} $direction={'vertical'} $spacing={36} $horizontalResizing={'fill'}>
            <HealthcareParentBasicDataPanel
               testId={'healthcareFacilityBasicData'}
               healthcareParentData={props.healthcareParentData}
               header={healthcareOrganizationTranslationKeys.healthcareFacilityParentData}
            />
            <HealthcareFacilityUnitUpdateFormLoader healthcareFacilityUnitId={props.healthcareFacilityUnitId}>
               {({ healthcareFacilityUnit }) => (
                  <HealthcareFacilityUnitUpdateForm
                     healthcareFacilityUnit={healthcareFacilityUnit}
                     healthcareParentData={props.healthcareParentData}
                  >
                     {({ handleSubmit, formState, setUnitCodeNotUniqueErrorMessage }) => (
                        <>
                           <HealthcareFacilityUnitUpdateModalConfirmButton
                              handleSubmit={handleSubmit}
                              setUnitCodeNotUniqueErrorMessage={setUnitCodeNotUniqueErrorMessage}
                              onDataChanged={props.onDataChanged}
                           />
                           <ModalCancelButton
                              label={commonTranslationKeys.cancel}
                              onClick={props.onCancel}
                              shouldConfirmExit={formState.isDirty}
                           />
                           <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
                        </>
                     )}
                  </HealthcareFacilityUnitUpdateForm>
               )}
            </HealthcareFacilityUnitUpdateFormLoader>
         </AutoLayout>
      </Modal>
   );
};
